<template>
    <form @submit.prevent ref="form" class="module-time-tracker">
        <h1 class="no-margin">{{dateHelper('D, d.m.Y', day)}}</h1>

        <div class="row spacer-20">
            <div class="col-4">
                <div><strong>Arbeitszeit</strong></div>
                <div v-if="dayEntry.work_time.string" class="flex-vertical-middle">
                    <span v-html="dayEntry.work_time.string" class="padding-right-5"/>
                    <span v-if="dayEntry.work_time.int && dayEntry.work_time.absence" class="padding-right-5">({{formatSeconds(dayEntry.work_time.int)}})</span>
                    <span v-if="overtimeAbsences[day]">(Stundenabbau {{overtimeAbsences[day].duration}})</span>
                </div>
                <div v-else>
                   <i class="material-icons" aria-hidden="true" role="img">remove</i>
                </div>

            </div>

            <div class="col-4">
                <div><strong>Anwesenheit</strong></div>
                <evaluation-attendances :attendances="dayEntry.data" :requested-corrections="requestedCorrections"/>
            </div>
        </div>

        <form-row label="Kommentar" class="spacer-20">
            <form-text-editor :id="ckId" name="note" v-model="note.note" :config="editorConfig"/>
        </form-row>
    </form>
</template>

<script lang="ts">
    import {FroalaToolbarRegular} from '@/library/froala';
    import {Component, Prop, Vue} from 'vue-facing-decorator';
    import FormRow from '../../../components/form/FormRow.vue';
    import FormTextEditor from '../../../components/form/FormTextEditor.vue';
    import formatSeconds from '../../../filters/formatSeconds';
    import {getFormData} from '../../../library/form';
    import {NOTE_DAY, saveTimeTrackerNote} from '../../../library/modules/time-tracker/time-tracker';
    import {popupDefaultCancelButton} from '../../../library/popup';
    import {deepCopyObject} from '../../../utils/portuna';
    import dateHelper from '../../../utils/portuna/dateHelper';
    import EvaluationAttendances from './EvaluationAttendances.vue';

    @Component({
        name: 'EvaluationDayNote',
        components: {
            EvaluationAttendances,
            FormTextEditor,
            FormRow,
        },
        methods: {
            dateHelper,
            formatSeconds,
        },
        emits: ['saved'],
    })
    export default class EvaluationDayNote extends Vue
    {
        readonly $refs: { form: HTMLFormElement };

        @Prop({
            type: Object,
            required: true,
        }) dayEntry: EvaluationDayEntry;

        @Prop({
            type: [Object, Array],
            required: false,
        }) overtimeAbsences: Record<string, {duration: number}>;

        @Prop({
            type: [Object, Array],
            required: true,
        }) requestedCorrections: Record<number, EvaluationRequestedCorrection>;

        @Prop({
            type: Number,
            required: true,
        }) employee: number;

        @Prop({
            type: String,
            required: true,
        }) day: string;

        editorConfig: Partial<FroalaOptions> = {
            toolbarButtons: FroalaToolbarRegular(),
            heightMin: 150,
        };

        get ckId()
        {
            return 'note-text-' + this._uid;
        }

        get note()
        {
            return this.dayEntry.note ? deepCopyObject(this.dayEntry.note) : {note: ''};
        }

        created()
        {
            let saveButton: PopupButton = {
                title: 'Kommentar speichern',
                icon: 'save',
                type: 'save',
                cmd: this.saveNote,
            };

            this.emitter.emit('setButtons', [popupDefaultCancelButton, saveButton]);
        }

        saveNote()
        {
            saveTimeTrackerNote(<{ note: string }>getFormData(this.$refs.form), this.note.id, this.employee, this.day, NOTE_DAY).then(note =>
            {
                this.emitter.emit('saved', note);
                this.$nextTick(() => this.emitter.emit('close'));
            });
        }
    }
</script>